import { Box } from "@mui/material";
import {
  AdditionalFormFieldProps,
  BaseFormFieldDefinition,
} from "@pimo/pimo-components/src/lib/pimo-components/pimo-form/form-field";
import { StatusDefinition } from "vmd-types";

import { Badge } from "../../components/badge";

export const QUESTIONNAIRE_SUBMISSION_STATUS_FIELD_TYPE =
  "questionnaireSubmissionStatus" as const;

export type QuestionnaireSubmissionStatusFieldDefinition =
  BaseFormFieldDefinition<typeof QUESTIONNAIRE_SUBMISSION_STATUS_FIELD_TYPE> & {
    value?: string;
    getValue?: () => string | undefined;
    definitions?: StatusDefinition[];
    getDefinitions?: () => StatusDefinition[] | undefined;
  };

export const QuestionnaireSubmissionStatusField = ({
  value,
  getValue,
  definitions,
  getDefinitions,
}: QuestionnaireSubmissionStatusFieldDefinition & AdditionalFormFieldProps) => {
  const resolvedValue =
    getValue?.() ?? value ?? definitions?.[0]?.name ?? undefined;
  const resolvedDefinitions = getDefinitions?.() ?? definitions;

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Badge value={resolvedValue} definitions={resolvedDefinitions} />
    </Box>
  );
};
